<template>
  <div>
    <CardWrapper
      :is-loading="false"
      :hasAccess="1"
    >
      <template #title>
        КАРТА МИРА
      </template>
      <template #icon>
        <WorldIcon/>
      </template>

      <vl-map
        :load-tiles-while-animating="true"
        :load-tiles-while-interacting="true"
        data-projection="EPSG:4326"
        style="height: 245px"
      >
        <vl-view :zoom.sync="zoom" :center="airportPosition" :rotation.sync="rotation"></vl-view>

        <vl-feature
          :id="'line-string-' + i"
          :key="'line-string-' + i"
          v-for="(item, i) in mapsArray"
        >
          <vl-geom-line-string
            :coordinates="arc(parseFloat(airportDetails.long), parseFloat(airportDetails.lat), parseFloat(item.long), parseFloat(item.lat))"
          ></vl-geom-line-string>
        </vl-feature>

        <vl-feature :id="'overlay-' + i" :key="'overlay-' + i" v-for="(item, i) in mapsArray">
          <vl-overlay
            positioning="top-center"
            :offset="[0, statLimit - i + 3]"
            :position="[parseFloat(item.long), parseFloat(item.lat)]"
          >
            <template slot-scope="scope">
              <div class="overlay-content">
                <v-card>
                  <v-card-text class="pa-1">{{ item.IATA }}</v-card-text>
                </v-card>
              </div>
            </template>
          </vl-overlay>
        </vl-feature>

        <vl-feature :id="'point-' + i" :key="'point-' + i" v-for="(item, i) in mapsArray">
          <vl-geom-point :coordinates="[parseFloat(item.long), parseFloat(item.lat)]"></vl-geom-point>
          <vl-style-box>
            <vl-style-circle :radius="(statLimit - i) * 2 || 2">
              <vl-style-fill color="#03a9f465"/>
              <vl-style-stroke color="#2196f3" :width="1"/>
            </vl-style-circle>
          </vl-style-box>
        </vl-feature>

        <!-- <vl-layer-tile id="osm">
          <vl-source-sputnik></vl-source-sputnik>
          <vl-source-osm></vl-source-osm>
        </vl-layer-tile> -->
        <vl-layer-tile>
          <vl-source-xyz :url="url"></vl-source-xyz>
        </vl-layer-tile>
      </vl-map>
    </CardWrapper>
  </div>
</template>

<script>
import arc from 'arc'
import store from '@/store'
import PerronIcon from "../ui/icons/PerronIcon.vue";
import CardWrapper from "../ui/CardWrapper.vue";
import WorldIcon from "../ui/icons/WorldIcon.vue";
export default {
  components: {WorldIcon, CardWrapper, PerronIcon},
  data() {
    return {
      url: 'https://mt.google.com/vt/lyrs=m&hl=ru&x={x}&y={y}&z={z}',
      statLimit: 15,
      zoom: 3,
      rotation: 0,
      geolocPosition: undefined,
      lineAccuracy: 50,
    }
  },
  methods: {
    arc: function(sx, sy, ex, ey) {
      let generator = new arc.GreatCircle({ x: sx, y: sy }, { x: ex, y: ey })
      let line = generator.Arc(this.lineAccuracy, { offset: 10 })
      let json = line.json()
      return json.geometry.coordinates
    },
    dirStatUpdate: function() {
      store.dispatch('maps/updateDirectionStatistic')
    },
  },
  computed: {
    directionStatistic: {
      get() {
        let ds = []
        ds = store.getters['maps/getDirectionStatistic']
        let lines = []
        ds.forEach(element => {
          if (element.lat !== null && element.long !== null) {
            lines.push(element)
          }
        })
        return lines.sort((a, b) => b.PaxCount - a.PaxCount)
      },
      set(value) {
        store.commit('maps/setDirectionStatistic', value)
      },
    },
    mapsArray() {
      let ds = [...this.directionStatistic] || []
      ds.sort((a, b) => b.PaxCount - a.PaxCount)
      return ds.slice(0, this.statLimit)
    },
    dirStatPreloader: function() {
      return store.getters['maps/getDirStatPreloader']
    },
    airportDetails: {
      get() {
        let detail = store.getters['getAirportDetails']
        this.center = [parseFloat(detail.long), parseFloat(detail.lat)]
        return detail
      },
      set(value) {
        store.commit('auth/setApDetail', value)
      },
    },
    airportPosition: {
      get() {
        return store.getters['getAirportPosition']
      },
    },
  },
}
</script>
